import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import reactFastclick from 'react-fastclick';
reactFastclick();

import configureStore from './stores/configureStore';

import App from './containers/App';
// import Editor from './components/editor/Editor';

import { entities } from './data/data';

const store = configureStore({
    entities
});

const rootElement = document.getElementById('mount');
// const rootEditorElement= document.getElementById('editor');

const render = (Component, element) =>
ReactDOM.render(
    <AppContainer>
        <Provider store={store}>
            <Component />
        </Provider>
    </AppContainer>,
    element
);

render(App, rootElement);
// render(Editor, rootEditorElement);

if (module.hot) {
    module.hot.accept('./containers/App', () => {
        const NextRoot = require('./containers/App').default;
        render(NextRoot, rootElement);

        // const NextEditor = require('./components/editor/Editor').default;
        // render(NextEditor, rootEditorElement);
    });
}


// WEBPACK FOOTER //
// ./app.js